import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
// ボタンクリックでメニューの開閉を制御する汎用ドロップダウン
export default class extends Controller {
  static targets = ["menu"]
  static classes = ["open"]

  get openClassName() {
    return this.hasOpenClass ? this.openClass : 'is-open'
  }

  toggle() {
    const isOpen = this.menuTarget.classList.contains(this.openClassName)
    this.menuTarget.classList.toggle(this.openClassName)
    this.dispatch(isOpen ? 'closed' : 'opened')
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.dismiss()
    }
  }

  dismiss() {
    const wasOpen = this.menuTarget.classList.contains(this.openClassName)
    this.menuTarget.classList.remove(this.openClassName)
    if (wasOpen) this.dispatch('closed')
  }
}
